<template>
	<form class="c-form-brief-create-url" @submit.prevent="onSubmit">
		<Form
			ref="form"
			:schema="schema"
			v-model="form"
			@status="saveStatus"
			buttonText="✨ Generate brief"
			:processing="processing"
			:errors="errors"
		></Form>
		<small v-if="!processing">
			Or <a href="#" @click.prevent="onSkip">skip this step.</a>
		</small>
		<small v-else> This will take 30-50 seconds. </small>
	</form>
</template>

<script>
import Form from './index.vue';

const schema = {
	url: {
		component: 'InputText',
		label: `Product/Service's landing page url`,
		placeholder:
			'Eg: https://www.shapellx.com/products/inner-armor-lycrafitsense-wireless-v-neck-bra',
		properties: {
			columnSize: 6,
		},
	},
};

export default {
	components: {
		Form,
	},

	data: function () {
		return {
			processing: false,
			schema: schema,
			form: {
				url: '',
			},
			errors: [],
			status: null,
		};
	},

	methods: {
		onSkip: function () {
			this.$emit('onSkip');
		},
		saveStatus: function (saveStatus) {
			this.status = saveStatus;
		},
		isUrl(str) {
			try {
				new URL(str);
				return true;
			} catch (err) {
				return false;
			}
		},
		async onSubmit() {
			this.errors = [];
			this.$refs.form.validate();

			if (this.status.invalid) {
				return;
			}

			let form = this.form;

			if (!this.isUrl(form.url)) {
				this.errors = [{ message: `Url isn't valid` }];
				return;
			}

			this.processing = true;

			let obj = {
				...form,
			};

			let res = await this.$store
				.dispatch('briefs/analyzeUrl', obj)
				.catch((err) => {
					console.log(err.response);
					if (err && err.response && err.response.data) {
						let message = err.response.data;
						this.errors.push({
							message: message,
						});
					} else {
						this.errors.push({
							message:
								'Something went wrong on our side. Try using a different url',
						});
					}
				});

			if (res) {
				this.$store.dispatch('message/sendMessage', {
					message: 'Landing page scanned!',
					timer: 3000,
					status: 'success',
				});
				this.$emit('onSubmit', res);
			}

			this.processing = false;
		},
	},
};
</script>

<style lang="scss"></style>
